export default __webpack_public_path__ + "static/media/logo.be9c6acf.svg";